<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Lista de Produtos</h3>
              <div class="card-tools d-flex align-items-center">
                <div class="input-group input-group-sm mr-2" style="width: 200px;">
                  <input type="text" name="table_search" class="form-control float-right" placeholder="Buscar..."
                    v-model="searchQuery" @keyup.enter="searchProducts">
                  <div class="input-group-append">
                    <button class="btn btn-default" @click="searchProducts">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                  <i class="fa fa-plus-square"></i>
                  Adicionar Novo
                </button>
              </div>
            </div>
          </div>
          <div class="card-body table-responsive p-0">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Descrição</th>
                  <th>Número UN</th>
                  <th>Nome Transporte</th>
                  <th>Guia até 50ml/50g</th>
                  <th>Guia acima de 50 ml ou 50 g até 4 L ou 4 kg > 50ml ou 50g <=4L ou 4kg</th>
                  <th>Guia acima de 4 L ou 4 kg > 4L ou 4kg</th>
                  <th>Guia Se orgão, parte do corpo ou corpo inteiro Quantidade liberada</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in products.data" :key="product.id">
                  <td>{{ product.id }}</td>
                  <td>{{ product.descricao | truncate(30, '...') }}</td>
                  <td>{{ product.numero_un }}</td>
                  <td>{{ product.nome_apropriado_transporte }}</td>
                  <td>
                    <a v-if="product.guia_ate_50ml_ou_50g" :href="product.guia_ate_50ml_ou_50g" target="_blank">Ver
                      PDF</a>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <a v-if="product.guia_acima_50ml_ou_50g_ate_4l_ou_4kg"
                      :href="product.guia_acima_50ml_ou_50g_ate_4l_ou_4kg" target="_blank">Ver PDF</a>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <a v-if="product.guia_acima_4l_ou_4kg" :href="product.guia_acima_4l_ou_4kg" target="_blank">Ver
                      PDF</a>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <a v-if="product.guia_orgao_parte_corpo_quantidade_liberada"
                      :href="product.guia_orgao_parte_corpo_quantidade_liberada" target="_blank">Ver PDF</a>
                    <span v-else>-</span>
                  </td>
                  <td>
                    <a href="#" @click="editModal(product)">
                      <i class="fa fa-edit blue"></i>
                    </a>
                    /
                    <a href="#" @click="deleteProduct(product.id)">
                      <i class="fa fa-trash red"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <pagination :data="products" @pagination-change-page="getResults"></pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-show="!editmode">Criar Novo Produto</h5>
            <h5 class="modal-title" v-show="editmode">Editar Produto</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <form @submit.prevent="editmode ? updateProduct() : createProduct()" enctype="multipart/form-data">
            <div class="modal-body">
              <div class="form-group">
                <label>Descrição</label>
                <input v-model="form.descricao" type="text" name="descricao" class="form-control"
                  :class="{ 'is-invalid': form.errors.has('descricao') }" />
                <has-error :form="form" field="descricao"></has-error>
              </div>
              <div class="form-group">
                <label>Número UN</label>
                <input v-model="form.numero_un" type="text" name="numero_un" class="form-control"
                  :class="{ 'is-invalid': form.errors.has('numero_un') }" />
                <has-error :form="form" field="numero_un"></has-error>
              </div>
              <div class="form-group">
                <label>Nome Apropriado para Transporte</label>
                <input v-model="form.nome_apropriado_transporte" type="text" name="nome_apropriado_transporte"
                  class="form-control" :class="{ 'is-invalid': form.errors.has('nome_apropriado_transporte') }" />
                <has-error :form="form" field="nome_apropriado_transporte"></has-error>
              </div>
              <!-- PDF inputs -->
              <div class="form-group">
                <label>Guia até 50ml ou 50g (Opcional)</label>
                <input type="file" name="guia_ate_50ml_ou_50g" class="form-control-file"
                  @change="handleFileUpload('guia_ate_50ml_ou_50g', $event)" />
                <!-- Exibe o nome do arquivo atual se estiver em modo de edição e houver arquivo -->
                <div v-if="editmode && form.guia_ate_50ml_ou_50g" class="mt-1">
                  <small>
                    Arquivo atual:
                    <a :href="form.guia_ate_50ml_ou_50g" target="_blank">
                      {{ getFileName(form.guia_ate_50ml_ou_50g) }}
                    </a>
                  </small>
                </div>
                <has-error :form="form" field="guia_ate_50ml_ou_50g"></has-error>
              </div>
              <div class="form-group">
                <label>Guia acima de 50ml/50g até 4l/4kg (Opcional)</label>
                <input type="file" name="guia_acima_50ml_ou_50g_ate_4l_ou_4kg" class="form-control-file"
                  @change="handleFileUpload('guia_acima_50ml_ou_50g_ate_4l_ou_4kg', $event)" />
                <!-- Exibe o nome do arquivo atual se estiver em modo de edição e houver arquivo -->
                <div v-if="editmode && form.guia_acima_50ml_ou_50g_ate_4l_ou_4kg" class="mt-1">
                  <small>
                    Arquivo atual:
                    <a :href="form.guia_acima_50ml_ou_50g_ate_4l_ou_4kg" target="_blank">
                      {{ getFileName(form.guia_acima_50ml_ou_50g_ate_4l_ou_4kg) }}
                    </a>
                  </small>
                </div>
                <has-error :form="form" field="guia_acima_50ml_ou_50g_ate_4l_ou_4kg"></has-error>
              </div>
              <div class="form-group">
                <label>Guia acima de 4l ou 4kg (Opcional)</label>
                <input type="file" name="guia_acima_4l_ou_4kg" class="form-control-file"
                  @change="handleFileUpload('guia_acima_4l_ou_4kg', $event)" />
                <!-- Exibe o nome do arquivo atual se estiver em modo de edição e houver arquivo -->
                <div v-if="editmode && form.guia_acima_4l_ou_4kg" class="mt-1">
                  <small>
                    Arquivo atual:
                    <a :href="form.guia_acima_4l_ou_4kg" target="_blank">
                      {{ getFileName(form.guia_acima_4l_ou_4kg) }}
                    </a>
                  </small>
                </div>
                <has-error :form="form" field="guia_acima_4l_ou_4kg"></has-error>
              </div>
              <div class="form-group">
                <label>Guia Órgão/Parte do Corpo/Quantidade Liberada (Opcional)</label>
                <input type="file" name="guia_orgao_parte_corpo_quantidade_liberada" class="form-control-file"
                  @change="handleFileUpload('guia_orgao_parte_corpo_quantidade_liberada', $event)" />
                <!-- Exibe o nome do arquivo atual se estiver em modo de edição e houver arquivo -->
                <div v-if="editmode && form.guia_orgao_parte_corpo_quantidade_liberada" class="mt-1">
                  <small>
                    Arquivo atual:
                    <a :href="form.guia_orgao_parte_corpo_quantidade_liberada" target="_blank">
                      {{ getFileName(form.guia_orgao_parte_corpo_quantidade_liberada) }}
                    </a>
                  </small>
                </div>
                <has-error :form="form" field="guia_orgao_parte_corpo_quantidade_liberada"></has-error>
              </div>
              <!-- ./PDF inputs -->
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Fechar
              </button>
              <button v-show="editmode" type="submit" class="btn btn-success">
                Atualizar
              </button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">
                Criar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  data() {
    return {
      editmode: false,
      products: {},
      searchQuery: '',
      form: new Form({
        id: '',
        descricao: '',
        numero_un: '',
        nome_apropriado_transporte: '',
        guia_ate_50ml_ou_50g: null,
        guia_acima_50ml_ou_50g_ate_4l_ou_4kg: null,
        guia_acima_4l_ou_4kg: null,
        guia_orgao_parte_corpo_quantidade_liberada: null
      }),
      files: {
        guia_ate_50ml_ou_50g: null,
        guia_acima_50ml_ou_50g_ate_4l_ou_4kg: null,
        guia_acima_4l_ou_4kg: null,
        guia_orgao_parte_corpo_quantidade_liberada: null
      }
    }
  },
  methods: {
    handleFileUpload(fieldName, event) {
      this.files[fieldName] = event.target.files[0];
    },
    getResults(page = 1) {
      this.$Progress.start();
      axios.get('api/product?page=' + page).then(({ data }) => (this.products = data.data));
      this.$Progress.finish();
    },
    loadProducts(search = '') {
      let url = 'api/product';
      if (search) {
        url += `?search=${encodeURIComponent(search)}`;
      }

      axios.get(url)
        .then(({ data }) => (this.products = data.data))
        .catch(() => {
          Toast.fire({
            icon: 'error',
            title: 'Ocorreu um erro ao carregar produtos'
          });
        });
    },
    searchProducts() {
      this.$Progress.start();
      let query = this.searchQuery.trim();
      let url = 'api/product';

      if (query) {
        url += `?search=${encodeURIComponent(query)}`;
      }

      axios.get(url)
        .then(({ data }) => {
          this.products = data.data;
          this.$Progress.finish();
        })
        .catch(() => {
          Toast.fire({
            icon: 'error',
            title: 'Ocorreu um erro ao buscar produtos'
          });
          this.$Progress.fail();
        });
    },
    editModal(product) {
      this.editmode = true;
      this.form.reset();
      $('#addNew').modal('show');
      this.form.fill(product);
    },
    newModal() {
      this.editmode = false;
      this.form.reset();
      $('#addNew').modal('show');
    },
    getFileName(url) {
      if (!url) return '';
      return url.split('/').pop();
    },
    createProduct() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append('descricao', this.form.descricao);
      formData.append('numero_un', this.form.numero_un);
      formData.append('nome_apropriado_transporte', this.form.nome_apropriado_transporte);
      for (let key in this.files) {
        if (this.files[key]) {
          formData.append(key, this.files[key]);
        }
      }
      axios.post('api/product', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((data) => {
          if (data.data.success) {
            $('#addNew').modal('hide');
            Toast.fire({
              icon: 'success',
              title: data.data.message
            });
            this.$Progress.finish();
            this.loadProducts();
          } else {
            Toast.fire({
              icon: 'error',
              title: 'Ocorreu um erro! Por favor, tente novamente'
            });
            this.$Progress.fail();
          }
        })
        .catch(() => {
          Toast.fire({
            icon: 'error',
            title: 'Ocorreu um erro! Por favor, tente novamente'
          });
        });
    },
    updateProduct() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append('descricao', this.form.descricao);
      formData.append('numero_un', this.form.numero_un);
      formData.append('nome_apropriado_transporte', this.form.nome_apropriado_transporte);
      for (let key in this.files) {
        if (this.files[key]) {
          formData.append(key, this.files[key]);
        }
      }
      formData.append('_method', 'PUT');
      axios.post('api/product/' + this.form.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          $('#addNew').modal('hide');
          Toast.fire({
            icon: 'success',
            title: response.data.message
          });
          this.$Progress.finish();
          this.loadProducts();
        })
        .catch(() => {
          this.$Progress.fail();
        });
    },
    deleteProduct(id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: "Você não será capaz de reverter isso!",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sim, excluir!'
      }).then((result) => {
        if (result.value) {
          this.form.delete('api/product/' + id).then(() => {
            Swal.fire(
              'Excluído!',
              'Seu produto foi excluído.',
              'success'
            );
            this.loadProducts();
          }).catch((data) => {
            Swal.fire("Falhou!", data.message, "warning");
          });
        }
      });
    }
  },
  created() {
    this.$Progress.start();
    this.loadProducts();
    this.$Progress.finish();
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix;
    },
  }
}
</script>